import { render } from "./HBEGlobalNotify.vue?vue&type=template&id=1b32d7b6&scoped=true"
import script from "./HBEGlobalNotify.vue?vue&type=script&lang=js"
export * from "./HBEGlobalNotify.vue?vue&type=script&lang=js"

import "./HBEGlobalNotify.vue?vue&type=style&index=0&id=1b32d7b6&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b32d7b6"]])

export default __exports__